import { useActivityLogger } from 'components/ActivityLogger'
import Button from 'components/Button'
import { API_ERROR_STATUS, API_ERROR_STATUS_IMAGES, commonMessages } from 'utils/messages'
// import { ReactComponent as ErrorFound } from 'assets/images/PageNotWorking.svg'
import { useEffect } from 'react'
import { errorNotify } from 'utils/toster'

//@ts-ignore

export function ErrorFallback({
	error,
	resetErrorBoundary,
	isNetworkError,
}: {
	error: Error
	resetErrorBoundary: (...args: Array<unknown>) => void
	isNetworkError: boolean
}) {
	const handleRetry = () => {
		window.location.assign(window.location.href)
	}

	const handleTryAgain = () => {
		window.location.assign(window.location.href)
		resetErrorBoundary()
	}

	// Error handling messages for network errors

	const networkErrors = (axiosStatus: number | null = 0) => {
		switch (axiosStatus) {
			case API_ERROR_STATUS.BAD_REQUEST:
				return API_ERROR_STATUS_IMAGES.BAD_REQUEST
			case API_ERROR_STATUS.UNAUTHORIZED:
				return API_ERROR_STATUS_IMAGES.UNAUTHORIZED
			case API_ERROR_STATUS.PAYMENT_REQUIRED:
				return API_ERROR_STATUS_IMAGES.PAYMENT_REQUIRED
			case API_ERROR_STATUS.FORBIDDEN:
				return API_ERROR_STATUS_IMAGES.FORBIDDEN
			case API_ERROR_STATUS.NOT_FOUND:
				return API_ERROR_STATUS_IMAGES.NOT_FOUND
			case API_ERROR_STATUS.METHOD_NOT_ALLOWED:
				return API_ERROR_STATUS_IMAGES.METHOD_NOT_ALLOWED
			case API_ERROR_STATUS.NOT_ACCEPTABLE:
				return API_ERROR_STATUS_IMAGES.NOT_ACCEPTABLE
			case API_ERROR_STATUS.PROXY_AUTHENTICATION_REQUIRED:
				return API_ERROR_STATUS_IMAGES.PROXY_AUTHENTICATION_REQUIRED
			case API_ERROR_STATUS.REQUEST_TIMEOUT:
				return API_ERROR_STATUS_IMAGES.REQUEST_TIMEOUT
			case API_ERROR_STATUS.CONFLICT:
				return API_ERROR_STATUS_IMAGES.CONFLICT
			case API_ERROR_STATUS.GONE:
				return API_ERROR_STATUS_IMAGES.GONE

			default:
				return API_ERROR_STATUS_IMAGES.SERVER
		}
	}

	useEffect(() => {
		const isChunkLoad = error?.name === 'ChunkLoadError'
		error?.message?.includes('Loading chunk') || error?.message?.includes('ChunkLoadError')
		const isChunkLoadError =
			error?.message?.includes('Loading chunk') || error?.message?.includes('ChunkLoadError')
		if ((isChunkLoadError || isChunkLoad) && !isNetworkError) {
			handleRetry()
		}
	}, [error])

	useActivityLogger(error as Error)
	return (
		<div role="alert" className="flex flex-col items-center justify-center h-full flex-1 gap-4">
			{
				// @ts-ignore
				<img src={networkErrors(error?.response?.status)} className="md:h-[670px] md:w-[1063px]" />
			}
			<Button onClick={handleTryAgain}>Try again</Button>
		</div>
	)
}
